import { createBrowserClient } from '@/lib/supabase/scoped-client';

type BrowserSupabaseClient = ReturnType<typeof createBrowserClient>;

let browserClient: BrowserSupabaseClient | null = null;

export function createClient() {
  const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL?.trim();
  const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY?.trim();

  if (!supabaseUrl || !supabaseAnonKey) {
    // During build/prerender, env vars may not be available
    // Return a no-op proxy that won't crash during SSR/static generation
    if (typeof window === 'undefined') {
      const noOp = () => ({ data: null, error: null });
      const noOpAsync = async () => ({ data: { user: null, session: null }, error: null });
      return new Proxy({} as BrowserSupabaseClient, {
        get: (_target, prop) => {
          if (prop === 'auth') return { getUser: noOpAsync, getSession: noOpAsync, signUp: noOpAsync, signInWithPassword: noOpAsync, resetPasswordForEmail: noOpAsync, updateUser: noOpAsync, signOut: noOpAsync, onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }) };
          if (prop === 'from') return () => ({ select: noOp, insert: noOp, update: noOp, delete: noOp });
          return noOp;
        },
      });
    }
    throw new Error(
      'Missing Supabase environment variables. Ensure NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_ANON_KEY are set.'
    );
  }

  if (!browserClient) {
    browserClient = createBrowserClient(supabaseUrl, supabaseAnonKey);
  }

  return browserClient;
}
